import {createEvent} from "./createEvent";

export const inertiaEvents = {
    started: createEvent(),
    finished: createEvent(),
    canceled: createEvent(),
    errored: createEvent(),
};
